// extracted by mini-css-extract-plugin
export var chevronIcon = "_ag-2";
export var teamName = "_ag-1";
export var teamSwitcherButton = "_ag-0";